import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getHasta, getFotoUrl, uploadFoto } from '../services/api';

// Seçilen görseli tarayıcıda JPEG'e küçült (en fazla maxKenar px)
function gorseliKucult(file, maxKenar = 1000, kalite = 0.85) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      let { width, height } = img;
      if (width > maxKenar || height > maxKenar) {
        if (width >= height) { height = Math.round(height * maxKenar / width); width = maxKenar; }
        else { width = Math.round(width * maxKenar / height); height = maxKenar; }
      }
      const canvas = document.createElement('canvas');
      canvas.width = width; canvas.height = height;
      canvas.getContext('2d').drawImage(img, 0, 0, width, height);
      canvas.toBlob(b => b ? resolve(b) : reject(new Error('blob')), 'image/jpeg', kalite);
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('görsel okunamadı')); };
    img.src = url;
  });
}

// Doğum tarihinden yıl/ay/gün kırılımı
function yasKirilim(dogTar) {
  if (!dogTar) return null;
  const d = new Date(dogTar);
  if (isNaN(d)) return null;
  const bugun = new Date();
  let yil = bugun.getFullYear() - d.getFullYear();
  let ay = bugun.getMonth() - d.getMonth();
  let gun = bugun.getDate() - d.getDate();
  if (gun < 0) { ay -= 1; gun += new Date(bugun.getFullYear(), bugun.getMonth(), 0).getDate(); }
  if (ay < 0) { yil -= 1; ay += 12; }
  return `${yil} yıl ${ay} ay ${gun} gün`;
}

function Alan({ etiket, deger, zorunlu }) {
  const bos = deger == null || String(deger).trim() === '' || String(deger).trim() === '-';
  return (
    <div className={'alan' + (zorunlu ? ' zorunlu' : '')}>
      <div className="alan-etiket">
        {zorunlu && <span className="zorunlu-nokta" />}
        {etiket}
      </div>
      <div className={'alan-deger' + (bos ? ' bos' : '')}>{bos ? '—' : deger}</div>
    </div>
  );
}

export default function HastaDetay() {
  const { kayitNo } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [h, setH] = useState(null);
  const [hata, setHata] = useState('');
  const [fotoVar, setFotoVar] = useState(false);
  const [fotoSurum, setFotoSurum] = useState(0);   // önbellek kırıcı
  const [fotoYukleniyor, setFotoYukleniyor] = useState(false);
  const dosyaRef = useRef(null);

  useEffect(() => {
    getHasta(kayitNo)
      .then(res => { setH(res.data); setFotoVar(!!res.data.fotoVar); })
      .catch(() => setHata('Hasta bulunamadı.'));
  }, [kayitNo]);

  const fotoSec = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = '';   // aynı dosya tekrar seçilebilsin
    if (!file) return;
    setFotoYukleniyor(true);
    try {
      const blob = await gorseliKucult(file);
      await uploadFoto(kayitNo, blob);
      setFotoVar(true);
      setFotoSurum(s => s + 1);
    } catch {
      alert('Fotoğraf yüklenemedi. Lütfen tekrar deneyin.');
    } finally {
      setFotoYukleniyor(false);
    }
  };

  if (hata) return <div className="kart kart-pad">{hata}</div>;
  if (!h) return <div className="kart kart-pad">Yükleniyor…</div>;

  const dogStr = h.dogTar ? new Date(h.dogTar).toLocaleDateString('tr-TR') : '';
  const cinsAd = h.cinsiyet === 'E' ? 'Erkek' : h.cinsiyet === 'K' ? 'Kadın' : '';
  const sabitTelVar = (h.tel || '').replace(/\D/g, '').length >= 7;

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span onClick={() => {
                const from = location.state?.from;
                if (from === 'muayene-detay') navigate(-1);
                else if (from === 'muayene-gecmis') navigate(-1);
                else navigate('/hastalar');
              }}
              style={{ color: 'var(--mor)', cursor: 'pointer', fontSize: 13.5, fontWeight: 600 }}>
          ← {location.state?.fromLabel ?? 'Hasta Listesine Dön'}
        </span>
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="btn-ikincil" onClick={() => navigate(`/hasta/${kayitNo}/muayeneler`)}>🩺 Muayeneler</button>
          <button className="btn" onClick={() => navigate(`/hasta/${kayitNo}/duzenle`)}>✏️ Düzenle</button>
        </div>
      </div>

      {/* Başlık kartı */}
      <div className="kart kart-pad" style={{ display: 'flex', alignItems: 'center', gap: 20, marginBottom: 18 }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
          <div className="foto-kutu" style={{ overflow: 'hidden', padding: 0 }}>
            {fotoVar
              ? <img src={`${getFotoUrl(kayitNo)}?t=${fotoSurum}`} alt="Hasta"
                     onError={() => setFotoVar(false)}
                     style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              : <span>👤</span>}
          </div>
          <input ref={dosyaRef} type="file" accept="image/*" capture="environment"
                 style={{ display: 'none' }} onChange={fotoSec} />
          <button type="button" className="btn-ikincil"
                  style={{ padding: '6px 14px', fontSize: 13 }}
                  disabled={fotoYukleniyor}
                  title="Fotoğraf ekle / değiştir"
                  onClick={() => dosyaRef.current && dosyaRef.current.click()}>
            {fotoYukleniyor ? '…' : (fotoVar ? '↻ Değiştir' : '＋ Foto')}
          </button>
        </div>
        <div style={{ flex: 1 }}>
          <h1 className="sayfa-baslik" style={{ marginBottom: 8 }}>{h.hesapAdi}</h1>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
            <span className="bilgi-rozet">Hasta No: {h.kayitNo}</span>
            {h.yas != null && <span className="bilgi-rozet">{h.yas} yaşında</span>}
            {cinsAd && <span className={'rozet ' + (h.cinsiyet === 'E' ? 'rozet-e' : 'rozet-k')}>{cinsAd}</span>}
            {h.kanGrubu && <span className="bilgi-rozet">🩸 {h.kanGrubu}</span>}
          </div>
        </div>

        {/* VIP ise fotoğrafın simetriği olarak sağda VIP kutusu */}
        {h.dur && (
          <div className="vip-kutu" title="VIP Hasta">
            <span className="tac">👑</span>
            <span className="yazi">VIP</span>
          </div>
        )}
      </div>

      {/* Kimlik Bilgileri */}
      <div className="kart kart-pad" style={{ marginBottom: 18 }}>
        <div className="bolum-baslik">🪪 Kimlik Bilgileri</div>
        <div className="detay-grid">
          <Alan etiket="Uyruk" deger={h.uyruk} />
          <Alan etiket={h.kimlikTuruAd || 'Kimlik No'} deger={h.kimlikNo} zorunlu />
          <Alan etiket="Adı - Soyadı" deger={h.hesapAdi} zorunlu />
          <Alan etiket="Doğum Yeri" deger={h.dogumYeri} zorunlu />
          <Alan etiket="Doğum Tarihi" deger={dogStr && `${dogStr}${yasKirilim(h.dogTar) ? '  (' + yasKirilim(h.dogTar) + ')' : ''}`} zorunlu />
          <Alan etiket="Anne Adı" deger={h.anneAdi} />
          <Alan etiket="Baba Adı" deger={h.babaAdi} />
          <Alan etiket="Kan Grubu" deger={h.kanGrubu} />
          <Alan etiket="Medeni Hali" deger={h.medeniHali} />
          <Alan etiket="Cinsiyet" deger={cinsAd} />
          <Alan etiket="Eğitim" deger={h.egitim} />
          <Alan etiket="KVKK Sözleşmesi" deger={h.kvkk} />
          <Alan etiket="Geliş Türü" deger={h.gelisTuru} zorunlu />
        </div>
      </div>

      {/* İletişim & Adres */}
      <div className="kart kart-pad" style={{ marginBottom: 18 }}>
        <div className="bolum-baslik">📍 İletişim & Adres</div>
        <div className="detay-grid">
          <Alan etiket="Şehir" deger={h.sehir} zorunlu />
          <Alan etiket="İlçe" deger={h.ilce} />
          <Alan etiket="Sabit Telefon" deger={sabitTelVar ? h.tel : ''} zorunlu />
          <Alan etiket="Cep Telefonu" deger={h.cepTel} />
          <Alan etiket="E-Posta" deger={h.eposta} />
        </div>
        <div style={{ marginTop: 6 }}>
          <Alan etiket="Adres" deger={h.adres} zorunlu />
        </div>
      </div>

      {/* Özel Notlar */}
      <div className="kart kart-pad">
        <div className="bolum-baslik">📝 Özel Notlar</div>
        <div className={'alan-deger' + ((h.ozelNotlar || '').trim() === '' ? ' bos' : '')} style={{ paddingTop: 6 }}>
          {(h.ozelNotlar || '').trim() === '' ? '—' : h.ozelNotlar}
        </div>
      </div>

      <div className="lejant"><span className="zorunlu-nokta" /> Zorunlu alanlar</div>
    </div>
  );
}
